
<template>
  <div :key="surveyId">
    <v-row
    style="width:100%;"
    justify="center"
    color="white"
    >
        <v-row justify="center" >
            <v-overlay
            :absolute="absolute"
            :value="overlay"
            opacity="1"
            >
            <v-container color="white">
                <v-card
                 class="justify-center"
                    width="100%"
                    max-width="600px"
                    min-width="320px"
                    style="max-height: 90vh;"
                    light
                >
                    <v-toolbar
                        color="#f17509 "
                        flat
                        dark
                    >
                    <v-toolbar-title color="#000000" style="font-weight: 450;">Frågor Mind</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn style="display:none;" @click="overlay = !overlay" icon color="white">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    </v-toolbar>
                    <div class="wrapper-survey" v-if="loaded === true" >
                    <v-container style="overflow: auto; max-height: 60vh;">
                      <v-row style="justify-content: center;">
                            <v-col style="max-width: 350px; font-size:14px;">
                                <i><span v-html="surveyInfoText"></span></i>
                            </v-col>
                        </v-row>
                        <br>
                        <v-divider></v-divider>

                        <v-row dense color="black" v-for="item in surveyObject" :key="item.id">
                            <v-col>
                                <v-card elevation="1">
                                 <v-card-text>
                                    <span style="font-weight: 450;">{{ item.question.Topic }} <span v-if="item.question.IsMandatory === 1">*</span></span>
                                </v-card-text>
                                    <Input :qAObject="item" v-if="item.question.DataType === 0" />
                                    <Radio :qAObject="item" v-if="item.question.DataType === 1" />
                                    <Selectbox :qAObject="item" v-if="item.question.DataType === 2" />
                                    <Checkbox :qAObject="item" v-if="item.question.DataType === 4" />
                                    <TextArea :qAObject="item" v-if="item.question.DataType === 3" />
                                </v-card>
                            </v-col>
                        </v-row>
                    <div class="pb-4 pt-4">
                        <span v-if="!surveyValid" style="font-style: italic;">Du har fyllt i {{this.uniqueAnswers.length || 'noll' }} av {{ this.mandatoryQuestions.length }} obligatoriska frågor</span>
                        <v-btn v-else color="#f17509" :loading="appliedSurvey" @click="saveSurvey()" small dark>Skicka</v-btn>
                    </div>
                    </v-container>

                    </div>
                    <div v-else>
                        <br><br>
                        <v-progress-circular 
                            indeterminate
                            color="#f17509"
                        ></v-progress-circular>
                    </div>
                    
                </v-card>
            </v-container>
            </v-overlay>
        </v-row>
    </v-row>

    <v-snackbar
      v-model="confirmationBar"
      timeout="3000"
    >
      Tack för dina svar!

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="confirmationBar = false"
        >
          Stäng
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import config from "../api/config";
import Radio from "./SurveyTypes/Radio.vue";
import Checkbox from "./SurveyTypes/Checkbox.vue";
import TextArea from "./SurveyTypes/TextArea.vue";
import Selectbox from "./SurveyTypes/Selectbox.vue";
import Input from "./SurveyTypes/Input.vue";

export default {
    props: ['caseId'],
    data() {
        return {
            val: 'Survey',
            config: config,
            absolute: true,
            overlay: false,
            surveyObject: [],
            loaded: false,
            chatCaseID: this.$props.caseId,
            appliedSurvey: false,
            surveyId: null,
            confirmationBar: false,
            surveyInfoText: '',
            surveyValid: false,
            uniqueAnswers: 0,
            mandatoryQuestions: 0,
        }
    },
    components: {
        Radio,
        Checkbox,
        TextArea,
        Selectbox,
        Input
    },
    computed: {
        surveyAnswers() {
            return this.$store.state.surveyAnswers;
        },
        surveyType() {
            return this.$store.state.surveyType;
        }
    },
    watch: {
        surveyType(val) {
            if(val.type === 'pre') {
                this.surveyInfoText = 'Innan du kopplas fram för att få chatta med en volontär vill vi be dig att svara på några korta frågor om ditt psykiska mående. Du kommer också efter avslutad chatt ombes att svara på några korta frågor om hur du mår. <br><br>Det är helt frivilligt att svara på frågorna och dina svar kommer inte synas för den volontär du chattar med. Svaren kommer att användas för att öka Minds kunskap om kontakterna i chatten och kommer analyseras med AI-teknik, det vill säga ett avancerat datorprogram. All information kommer att avidentifieras för att skydda din anonymitet. '
            } else {
                this.surveyInfoText = 'Vi skulle nu vilja be dig svara på två frågor efter ditt chattsamtal. Det är helt frivilligt att svara på frågorna och dina svar kommer inte synas för den volontär du chattade med.';
            }
            this.runSurvey(val.type,this.config.customer.uniqueChat,val.surveyId);
        },
        surveyAnswers: {
            deep: true, 
            immediate: true,
            handler(val) {
       

                var uniqueAnswersArr = [];
                if(val.length === 0) {
                    this.surveyValid = false
                    return;
                }

                // Filter out unique questions and if they are valid and mandatory 
                val.forEach(function(item){
                var i = uniqueAnswersArr.findIndex(x => x.questionId == item.questionId);
                if(i <= -1){
                    console.log("item",item);
                    if(item.isMandatory === 1 && item.surveyValid === true) {
                        uniqueAnswersArr.push(item);
                    }
                }
                });

         
                this.uniqueAnswers = uniqueAnswersArr;

                // Compare if the mandatory questions are the same as the unique answers that are mandatory
                if(this.uniqueAnswers.length === this.mandatoryQuestions.length) {
                    this.surveyValid = true;
                } else {
                    this.surveyValid = false;
                }
            }
        }
    },
    methods: {

        async saveSurvey() {
            if(this.surveyValid === false) return alert("Surveyn är inte valid, försök igen");
            this.appliedSurvey = true;
            if(this.surveyId === null || this.chatCaseID === 0) {
                alert("Tekniskt fel kunde inte spara survey, stäng sidan och försök igen");
                return;
            }
            if(this.surveyAnswers.length === 0) {
                this.appliedSurvey = false;
                alert("Surveyen saknar svar");
                return;
            }
            
            try {
                
                await this.$store.dispatch('saveSurvey', { data: this.surveyAnswers, surveyId: this.surveyId, refId: this.chatCaseID || '0' });
                this.overlay = false;
                this.appliedSurvey = false;
                this.confirmationBar = true;
                this.uniqueAnswers = 0;
                this.mandatoryQuestions = 0;
                
                if(this.surveyType.type === 'pre') {
                    localStorage.setItem('__surveyAnsw', this.surveyType.type);
                }
                
            } catch (error) {
                this.appliedSurvey = false;
                console.warn("Något gick fel när sparande av frågor skulle genomföras ", new Date());
            }
        },
        async runSurvey(type,guid,surveyId) {
            try {
                this.surveyId = surveyId;
                this.surveyObject = await this.$store.dispatch("getSurvey",{ type:type, id: surveyId,guid: guid});
            
                if(this.surveyObject.length > 0) {
                    this.loaded = true;
                    this.overlay = true;
                    const onlyQuestions = [...new Set(this.surveyObject.map(item => item.question))];
                    this.mandatoryQuestions = [...new Set(onlyQuestions.filter(item => item.IsMandatory === 1))];

                } else {
                    this.loaded = false;
                    this.overlay = false;
                }
                this.loaded = true;
            } catch (error) {
                 this.overlay = true;
                 console.warn("Error inside survey component", error, " ", new Date());
            }
        }
    },
}
</script>

<style>

</style>
